/*
  Quick add to cart (Watercolor Atlas).
  - Delegated click handler for [data-dw-quick-add] buttons.
  - POSTs the variant to /cart/add.js, then fetches /cart.js and dispatches
    'cart:updated' on document with { detail: { cart } }.
  - Opens the cart drawer via window.DWCart.open() when a drawer is present.
  - Idempotent: safe to include the script tag more than once per page.
*/
(function () {
  'use strict';

  if (window.__dwQuickAddInit) return;
  window.__dwQuickAddInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setLabel(button, key) {
    var el = button.querySelector('.dw-quick-add__label');
    var text = button.getAttribute('data-label-' + key);
    if (el && text) el.textContent = text;
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var button = event.target.closest('[data-dw-quick-add]');
    if (!button || button.disabled || button.classList.contains('is-busy')) return;

    event.preventDefault();

    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    /* Tells dw-cart.js's OCU rescue net this add is handled first-party */
    window.__dwAtcHandled = Date.now();

    button.classList.add('is-busy');
    button.setAttribute('aria-disabled', 'true');
    setLabel(button, 'adding');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function (item) {
        /* The add succeeded; everything past here is drawer refresh and must
           never surface as an error (Shopify throttles /cart.js under burst,
           and a failed refresh used to show "Try Again" for an item that WAS
           added, inviting double-add retries). */
        setLabel(button, 'added');
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (response) { return response.ok ? response.json() : null; })
          .catch(function () { return null; })
          .then(function (cart) {
            if (cart) {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            } else {
              document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: item } }));
            }
            if (window.DWCart && typeof window.DWCart.open === 'function') {
              window.DWCart.open();
            }
          });
      })
      .catch(function () {
        setLabel(button, 'error');
      })
      .finally(function () {
        button.classList.remove('is-busy');
        button.removeAttribute('aria-disabled');
        window.setTimeout(function () {
          setLabel(button, 'default');
        }, 2400);
      });
  });
})();
